import { Component, Input, OnInit } from '@angular/core';
import {
    MissionWorkflowDto,
    MissionWorkflowVersionDto,
    StepDescription,
    WorkflowAttachmentRequirement,
    WorkflowHandler,
    WorkflowMappedEntityDetails
} from '@flyfreely-portal-ui/flyfreely';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { cleanSteps } from '../helpers';

@Component({
    selector: 'workflow-view-dialogue',
    templateUrl: './workflow-view-dialogue.component.html',
    styleUrls: ['./workflow-view-dialogue.component.scss']
})
export class WorkflowViewDialogue implements OnInit {
    @Input() steps: StepDescription[];
    @Input() workflowHandler: WorkflowHandler;
    @Input() workflow: MissionWorkflowDto;
    @Input() hasDelegatedAuthority: boolean;
    @Input() hasName: boolean;
    @Input() hasApproverChecks: boolean;

    currentVersion: {
        id: number;
        versionNumber: number;
        mappedForms: { [step: string]: WorkflowMappedEntityDetails[] };
        mappedAttachmentRequirements: {
            [step: string]: WorkflowAttachmentRequirement[];
        };
        mappedApproverChecks: { [step: string]: any[] };
        delegatedAuthorityId: number;
        additionalAuthorityIds: number[];
    };

    versions: MissionWorkflowVersionDto[];
    activeVersionId: number;

    constructor(public modal: BsModalRef<WorkflowViewDialogue>) {}

    ngOnInit() {
        if (this.workflow) {
            this.versions = this.workflow.versions;
            this.activeVersionId = this.workflow.activeVersionId;

            const activeVersion = this.workflow.activeVersionId
                ? this.workflow.versions?.find(
                      v => v.id === this.workflow.activeVersionId
                  )
                : this.workflow.versions?.[this.workflow.versions.length - 1];

            if (activeVersion) {
                this.currentVersion = {
                    id: activeVersion.id,
                    versionNumber: activeVersion.versionNumber,
                    mappedForms: cleanSteps(
                        this.steps,
                        activeVersion.mappedForms
                    ),
                    mappedAttachmentRequirements: cleanSteps(
                        this.steps,
                        activeVersion.mappedAttachmentRequirements,
                        false
                    ),
                    mappedApproverChecks: cleanSteps(
                        this.steps,
                        // @ts-ignore: these exist on authority workflows
                        activeVersion.mappedApproverChecks,
                        false
                    ),
                    delegatedAuthorityId: activeVersion.delegatedAuthorityId,
                    additionalAuthorityIds:
                        activeVersion.additionalAuthorityIds ?? []
                };
            }
        }
    }

    filterSteps() {
        return this.steps.filter(
            step => step.editable === false || step.editable === true
        );
    }

    countOf(step: string) {
        if (!this.currentVersion) {
            return 0;
        }
        return (
            (this.currentVersion.mappedForms[step]?.length ?? 0) +
            (this.currentVersion.mappedAttachmentRequirements[step]?.length ??
                0)
        );
    }
}
